/**
 * * * *  * *******************************************************************************************************
 * * V1.7
 *
 * User: danielr
 * Date: 26/08/14
 *
 * + now bubble will by default closes after a timeout (500 ms). To disable this feature, send preventCloseOnBubbleMouseEnter: false
 *
 *
 * * *  * *******************************************************************************************************
 * * V1.6
 *
 * User: shlomif
 * Date: 17/02/14
 *
 * + Add option to pass a View to the bubble which is rendered as content.
 * + Add MOUSE_ENTER and MOUSE_LEAVE events.
 *
 * new options:
 *
 * + contentView: instance of Marionette.View - should be an instance of a view and not just the view 'class' function.
 *                                              The Bubble component renders the view, append it to the DOM and closes
 *                                              it when the bubble is closed.
 *
 * * *  * *******************************************************************************************************
 * * V1.5
 *
 * User: danielr
 * Date: 14/01/14
 *
 * use of the PositionUtils position() method for the positioning
 *
 * *  * *******************************************************************************************************
 * * V1.4
 *
 * User: danielr
 * Date: 17/12/13
 *
 * bubble alignment feature.
 * options:
 * - align [Bubble.ALIGN] optional - default: Bubble.ALIGN.MIDDLE
 *
 *  * *******************************************************************************************************
 * V1.32
 *
 * User: danielr
 * Date: 25/11/13
 *
 * bubble delay feature.
 * options:
 * - isDelayed [true/false] optional - default: false
 * - delay [int] optional - the value in ms
 *
 *  * *******************************************************************************************************
 * V1.31
 *
 * User: danielr
 * Date: 19/8/13
 * https://docs.google.com/a/liveperson.com/file/d/0B8IBNMmJWXC2LTVsX24xVVJIcHc/edit
 *
 * due to bug CFE-1734 the Popover component has been renamed to the Bubble component.
 * If Ad Block plugin (very popular ad blocker plugin) is used in the Chrome or Firefox browser, it will block the loading of the Popover.js as it holds the following blocking filter:
 * /popover/*$script
 * This means that any script under the popover directory is blocked resulting on the page not being loaded (in DEV env only)
 * No such filter with the Bubble name.
 *
 *  * *******************************************************************************************************
 * V1.3
 *
 * User: danielr
 * Date: 12/8/13
 * https://docs.google.com/a/liveperson.com/file/d/0B8IBNMmJWXC2LTVsX24xVVJIcHc/edit
 *
 * new options:
 * - permutation for sizes. see the pdf for details. default: B
 * - title [optional]
 * - buttonCaption: caption of the button located in the action area [optional - required if buttonCallback is passed]
 * - buttonCallback: callback when the button is clicked [optional - required if buttonCaption is passed]
 * - buttonPermutation: permutation for the button [optional]
 *
 * example of use:
 *
 * this.uiComponents.host$.createAndRender("pop", {
 *                   type: Popover,
 *                   options: {
 *                       targetControl: this.ui.btnShow,
 *                       permutation: Popover.PERMUTATION.C,
 *                       title: "my first title!",
 *                       text: "<strong>Hello</strong> Popover! <strong>Hello</strong> Popover! <i>Hello</i> Popover! <strong>Hello</strong> Popover! <strong>Hello</strong> Popover! ",
 *                       position: Popover.POSITION.TOP,
 *                       icon: Popover.ICON.ERROR,
 *                       showCloseButton: true,
 *                       buttonCaption: "Connect to Google",
 *                       buttonCallback: function(txt){
 *                          that.popoverCallback(txt);
 *                         },
 *                     theme: Popover.THEME.DARK
 *                   }
 *                   });
  *  * *******************************************************************************************************
 *
 * V1.0
 *
 * User: danielr
 * Date: 25/7/13
 * Visual PDF: https://drive.google.com/a/liveperson.com/?pli=1#folders/0BzCszeQVU73yUU8wdVdsMW41Qzg
 * The Popover component replaces the on demand feature of the current Tooltip component.
 * This means that the On Demand feature of the Tooltip will be obsolete and will be removed.
 * This is the responsibility of the developers to make the required changes according to the below guide.
 *
 * The version 1.0 of the Popover component uses the same design used for the current Tooltip (1.3).
 * However, the Popover component has the following additions:
 *
 *  html tags support
 *  multi instances
 *  option to display a close button
 *  is called on demand only
 *  Theme, position and icons are still supported.
 *
 *  !!! ATTENTION !!!
 *  DUE TO THE FACT THAT HTML TAG IS SUPPORTED, THIS IS THE RESPONSIBILITY OF THE DEVELOPER TO MAKE SURE THE POPOVER IMPLEMENTATION DOES NOT BREAK THE DESIGN OF THE WHOLE PAGE/APP EVEN WHEN TRANSLATION IS APPLIED.
 *  THE DEVELOPER IS ALSO RESPONSIBLE TO MAKE SURE THE TEXT PASSED IN THE OPTION IS XSS FREE
 *
 *  Supported options:
 *  targetControl (the control el to which you want to apply the Popover) - required
 *  text (the text to be displayed in then Popover. supports html) - optional
 *  position (Popover.POSITION.BOTTOM, Popover.POSITION.TOP, Popover.POSITION.RIGHT, Popover.POSITION.LEFT) - optional. default: Popover.POSITION.TOP
 *  icon (Popover.ICON.ERROR) - optional
 *  theme (Popover.THEME.DARK) - optional
 *  showCloseButton (show the X for closing the Popover) - optional. default: false
 *
 *  Implementation in your view:
 *  - require:
 *  var Popover = require("ui/popover/Popover");
 *  - in your view definition:
 *  withUIComponents: true
 *  - to display the Popover:
 *  this.uiComponents.host$.createAndRender(id, {
 *                     type: Popover,
 *                     options: {
 *                         targetControl:this.ui.input,
 *                         text: "<strong>Hello</strong> Popover",
 *                         position: Popover.POSITION.BOTTOM,
 *                         icon: Popover.ICON.ERROR,
 *                         showCloseButton:true,
 *                         theme: Popover.THEME.DARK
 *                     }
 *                 });
 *  id is the id of the Popover instance.
 *  - to close the Popover:
 *  if (this.uiComponents.hasOwnProperty(id)){
 *      this.uiComponents[id].close();
 * }
 * *******************************************************************************************************
 */
define(function (require) {
    "use strict";
    var _ = require("underscore");
    var Marionette = require("marionette");
    var Logger = require("logger");
    var template = require("ui/bubble/templates/bubble.tmpl");
    var BubbleModel = require("ui/bubble/js/models/BubbleModel");
    var PositionUtils = require("ui/PositionUtils");
    var $ = require("jquery");
    var HtmlSanitizerUtils = require("HtmlSanitizerUtils");

    var REPORTING_CLASS = "reporting-wrapper";
    var CONNECTION_PANEL_CLASS = "connection-panel-wrapper";
    var PERSONALIZATION_PANEL_CLASS = "personalization-bar-wrapper";
    var DEFAULT_ZINDEX = 1999;

    var Bubble = Marionette.ItemView.extend({
        version: "1.7",
        withUIComponents: true,
        config: {
            cls: {
                region: {
                    dark: "div.dark"
                },
                theme: {
                    dark: "dark",
                    "light-theme":"light-theme"
                },
                icon: {
                    error: "error",
                    "warning-white": "warning-white",
                    "success": "success",
                    "success-white": "success-white",
                    "progress": "progress"
                }
            },
            themeMap: {
                1: "dark",
                2: "light-theme"
            },
            iconMap: {
                1: "error",
                2: "warning-white",
                3: "success",
                4: "success-white",
                5: "progress"
            },
            defaultBubbleDelay: 500,
            defaultBubblePosition: 1, //TOP
            defaultBubbleAlign: 1,     //MIDDLE
            defaultBubbleZIndex: DEFAULT_ZINDEX
        },
        template:template,

        ui:{
            bubble: ".bubble",
            content: ".content",
            closeBubble: ".closeBubble",
            title: ".title",
            action: ".action",
            actionButton: ".btn-action",
            iconWrap: ".icon-container",
            icon: ".icon"
        },

        events:{
            "click .closeBubble":"hideBubble",
            "mouseenter .bubble": "onMouseEnter",
            "mouseleave .bubble": "onMouseLeave",
            "click .bubble": "onBubbleClick"
        },

        initialize:function (options) {
            var defaultOptions = {
                text: "",
                position: this.config.defaultBubblePosition,
                showCloseButton: false,
                title: "",
                showButton: false,
                permutation: Bubble.PERMUTATION.B,
                buttonCaption: "",
                align: this.config.defaultBubbleAlign,
                preventCloseOnBubbleMouseEnter: true,
                zIndex: this.config.defaultBubbleZIndex,
                containerSelector: ".bubble-component-container"
            };
            options = $.extend({}, defaultOptions, options );
            this.initializeMaps();
            var positioning = this.initializePositioning(options.position, options.align);

            this.text = options.text;
            this.title = options.title;
            this.delay = options.delay;
            this.isDelayed = options.isDelayed;
            this.ignoreOffsetByContainer = options.ignoreOffsetByContainer;
            this.targetControl = options.targetControl;
            this.buttonCallback = options.buttonCallback;
            this.buttonCaption = options.buttonCaption;
            this.permutation = options.permutation;
            this.showCloseButton = options.showCloseButton;
            this.buttonPermutation = options.buttonPermutation;
            this.theme = options.theme;
            this.icon = options.icon;
            this.onBubbleClose = options.onBubbleClose;
            this.contentView = options.contentView;
            this.preventCloseOnBubbleMouseEnter = options.preventCloseOnBubbleMouseEnter;
            this.onClick = options.onClick;
            this.zIndex = options.zIndex;
            this.containerSelector = options.containerSelector;

            this.position = positioning.pos;
            this.align = positioning.align;

            var sanitizedText = HtmlSanitizerUtils.sanitizeHtml(this.text);
            this.badSanitize = sanitizedText.sanitized;

            this.logger = Logger.getLogger("Bubble");
            var bubbleModel = new BubbleModel({});
            bubbleModel.set("text", this.text);
            bubbleModel.set("title", this.title);
            this.model = bubbleModel;
        },

        initializeMaps: function(){
            this.positionMap = {};
            this.positionMap[Bubble.POSITION.TOP] = PositionUtils.PositionEntity.POSITION.TOP;
            this.positionMap[Bubble.POSITION.BOTTOM] = PositionUtils.PositionEntity.POSITION.BOTTOM;
            this.positionMap[Bubble.POSITION.LEFT] = PositionUtils.PositionEntity.POSITION.LEFT;
            this.positionMap[Bubble.POSITION.RIGHT] = PositionUtils.PositionEntity.POSITION.RIGHT;
            this.alignMap = {};
            this.alignMap[Bubble.ALIGN.LEFT] = PositionUtils.PositionEntity.ALIGN.LEFT;
            this.alignMap[Bubble.ALIGN.RIGHT] = PositionUtils.PositionEntity.ALIGN.RIGHT;
            this.alignMap[Bubble.ALIGN.MIDDLE] = PositionUtils.PositionEntity.ALIGN.MIDDLE;
            this.alignMap[Bubble.ALIGN.TOP] = PositionUtils.PositionEntity.ALIGN.TOP;
            this.alignMap[Bubble.ALIGN.BOTTOM] = PositionUtils.PositionEntity.ALIGN.BOTTOM;
        },

        initializePositioning: function(pos, align){
            var result = {pos:pos, align:align};
            if (align !== Bubble.ALIGN.MIDDLE){
                if ((align === Bubble.ALIGN.RIGHT || align === Bubble.ALIGN.LEFT) && (pos === Bubble.POSITION.LEFT || pos === Bubble.POSITION.RIGHT)){
                    result.pos = Bubble.POSITION.TOP;
                }
                else if ((align === Bubble.ALIGN.TOP || align === Bubble.ALIGN.BOTTOM) && (pos === Bubble.POSITION.TOP || pos === Bubble.POSITION.BOTTOM)){
                    result.pos = Bubble.POSITION.RIGHT;
                }
            }
            return result;
        },

        /***
         *  onRender: renders the bubble.
         *  we first reset the current css class and apply the new ones
         */
        onRender:function () {
            if (this.isOptionValid()) {
                this.container = $(this.targetControl).parents(this.containerSelector);
                this.offset = _initOffset(this.container, this.ignoreOffsetByContainer);
                $(this.el).appendTo(this.container);
                var delay = !_.isUndefined(this.delay) ? this.delay : 0;
                delay = (!_.isUndefined(this.isDelayed) && delay === 0) ? this.config.defaultBubbleDelay : delay;
                if (delay > 0) {
                    var that = this;
                    setTimeout(function () {
                        that.showBubble();
                    }, delay);
                }
                else {
                    this.showBubble();
                }
            }

        },

        isOptionValid: function(){
            var result = true;
            var graphObj = {};
            var alertText = "";
            var IsButtonCallback = !(_.isUndefined(this.buttonCallback) && this.buttonCallback !== null);
            if(this.badSanitize){
                this.logger.error("Bubble:SanitizeError","Bubble::isOptionValid", this.text);
                graphObj = {name: "UIComponents:Bubble:SanitizeError" };
                alertText ="Pardon my language but your Bubble message contains possible XSS code. Please take note and fix it ASAP.";
                result = false;
            } else if (_.isUndefined(this.targetControl) || this.targetControl === null){
                this.logger.error("targetControl for Bubble widget is mandatory","Bubble:isOptionValid");
                graphObj = {name: "UIComponents:Bubble:SanitizeError:NoTargetControl" };
                alertText ="Pardon my language but your Bubble message does not contain targetcontrol. Please take note and fix it ASAP.";
                result = false;
            } else if (this.buttonCaption === "" && IsButtonCallback){
                this.logger.error("buttonCaption can NOT be empty when supplying buttonCallback","Bubble:isOptionValid");
                graphObj = {name: "UIComponents:Bubble:SanitizeError:ButtonCaptionEmpty" };
                alertText ="Pardon my language but your Bubble caption is empty. Please take note and fix it ASAP.";
                result = false;
            }
            else if (this.buttonCaption !== "" && !IsButtonCallback){
                this.logger.error("buttonCallback is required when supplying buttonCaption","Bubble:isOptionValid");
                graphObj = {name: "UIComponents:Bubble:SanitizeError:NoButtonCallback" };
                alertText ="Pardon my language but your Bubble message does not contain buttonCallback. Please take note and fix it ASAP.";
                result = false;
            }

            if (!result){
                this.logger.graph(graphObj);
            }


            return result;
        },

        setTitle: function(){
            if (this.title !== ""){
                this.ui.title.removeClass("hide");
            }
        },

        setPermutation: function(){
            this.ui.bubble.addClass("perm-" + this.permutation);
        },

        hasActionButton: function(){
            return this.buttonCaption !== "";
        },

        hasCloseButton: function(){
            return this.showCloseButton;
        },

        setActionButton: function () {
            if (this.hasActionButton()) {
                this.ui.action.removeClass("hide");
                var that = this;
                var hosts = this.uiComponents.host$;
                //this is the solution for circular reference issue between the Button and Bubble components.
                //the load of the button in the bubble is done inline.
                require(["ui/button/Button"], function (Button) {
                    hosts.createAndRender("btn", {
                        type: Button,
                        options: {
                            el: that.ui.actionButton,
                            permutation: _.isUndefined(that.buttonPermutation) ? Button.PERMUTATION.BTN : that.buttonPermutation,
                            initState: Button.STATES.ENABLED,
                            onClick: _.bind(that.invokeCloseButtonAction, that),
                            text: that.buttonCaption,
                            tooltip: ""
                        }
                    });
                    that.setPosition();
                });
            }
        },

        invokeCloseButtonAction: function(){
            try {
                var result = this.buttonCallback(this.buttonCaption);
                if (result !== false) {
                    this._closeBubble(true);
                }
            }
            catch (e) {
                this.logger.error("global error - type: " + e.name + " err: " + e.message,"Bubble:invokeCloseButtonAction");
                this.logger.graph({ name: "UIComponents:Bubble:invokeCloseButtonActionError"});

                //this.close();
            }
        },

        /***
         * setTheme: set the theme class
         */
        setTheme: function(){
            if (this.theme){
                this.ui.bubble.addClass(this.config.cls.theme[this.config.themeMap[this.theme]]);
            }
            else if ($(this.targetControl).closest(this.config.cls.region.dark).length > 0){
                this.ui.bubble.addClass(this.config.cls.theme.dark);
            }
        },

        /***
         * setIcon: set the icon class
         */
        setIcon:function(){
            if (this.icon){
                this.ui.iconWrap.removeClass("hide");
                this.ui.icon.addClass(this.config.cls.icon[this.config.iconMap[this.icon]]);
            }
        },

        setCloseButton: function(){
            //$(this.ui.closeBubble).toggle("hide");
            if (!this.showCloseButton){
                this.ui.closeBubble.addClass("hide");
            }
            else {
                this.ui.bubble.addClass("with-close");
            }
        },

        onPositionCalculated: function(pos){
            var leContainerTop = this.container.offset().top;
            var leContainerLeft = this.container.offset().left;
            if (pos.isValid){
                this.ui.bubble.addClass(pos.cls);
                this.ui.bubble.css({"top": pos.top - leContainerTop + this.offset.top, "left": pos.left - leContainerLeft + this.offset.left});
                this.display();
            }
            else {
                this.logger.error(pos.err);
                this.logger.graph({ name: "UIComponents:Bubble:onPositionCalculated:posInvalid"});
            }
        },

        /***
         *  setPosition: sets the position of the bubble
         */
        setPosition: function(){
            PositionUtils.position({
                targetEl: this.targetControl,
                floatingEl: this.ui.bubble,
                position: this.positionMap[this.position],
                align: this.alignMap[this.align]
            }, _.bind(this.onPositionCalculated, this));
        },

        hideBubble: function(){
            //this.ui.bubble.hide();
            if(!_.isUndefined(this.onBubbleClose) && _.isFunction(this.onBubbleClose)){
                this.onBubbleClose();
            }
            this._closeBubble(true);
        },

        setCss: function(){
            var text = this.model.get("text");

            // Do not set word-break style when no text is set
            if(_.isEmpty(text)) {
                return;
            }

            var m = text.match(/\s/g);
            if (m === null){
                this.ui.content.addClass("break-all");
            }
            else{
                if (m.length < 2){
                    this.ui.content.addClass("break-all");
                }
                else{
                    this.ui.content.removeClass("break-all");
                }
            }

        },

        setZIndex: function () {
            this.ui.bubble.css("zIndex", this.zIndex);
        },

        display: function(){
            this.ui.bubble.css("display", "block");
        },

        setContentView: function () {
            if (this.contentView && this.contentView instanceof Marionette.View) {
                this.contentView.delegateEvents();
                this.contentView.render();
                this.ui.content.append(this.contentView.el);
            }
        },

        showBubble: function(){
            //this.ui.bubble.show();
            if (_.isObject(this.ui.bubble)){
                this.setContentView();
                this.setPermutation();
                this.setCss();
                this.setZIndex();
                this.setTitle();
                this.setTheme();
                this.setIcon();
                this.setCloseButton();
                this.setActionButton();
                if (!this.hasActionButton()){ /*for some reason if bubble has a button the set position is calculated before the button is actually renderred. now if the bubble has a button the setPosition will be called right after the button is renderred*/
                    this.setPosition();
                }
                this.setCursor();
            }
        },

        onMouseEnter: function() {
            if (this.preventCloseOnBubbleMouseEnter){
                this.mouseEnterTriggered = true;
            }
        },

        onMouseLeave: function() {
            if (!this.hasCloseButton() && this.mouseEnterTriggered){
                this._closeBubble(true);
            }
        },

        close: function(forceClose){
            if (forceClose) {
                this._closeBubble(true);
                return;
            }
            if (this.hasCloseButton() && (this.targetControl && ((!_.isUndefined(this.targetControl.html) && this.targetControl.html() === "") || (!_.isUndefined(this.targetControl.innerHTML) && this.targetControl.innerHTML === "")))){//the targetControl.html() is empty in case of the implemented page closes itself and uicomponents are automatically closed
                this._closeBubble(true);
                return;
            }
            if (this.preventCloseOnBubbleMouseEnter){
                setTimeout(_.bind(function(){this._closeBubble(false);}, this), Bubble.TIMEOUT);
                return;
            }
            this._closeBubble(true);
        },

        _closeBubble: function(forceClose){
            // close bubble only if not hovered or if forced
            if (forceClose || !this.mouseEnterTriggered){
                Marionette.ItemView.prototype.close.apply(this);
            }
        },


        onClose: function() {
            if(!_.isUndefined(this.contentView)) {
                this.contentView.close();
            }
        },
        onBubbleClick:function(){
            if(_.isFunction(this.onClick)){
                this.onClick();
            }
        },
        setCursor: function () {
            if (_.isFunction(this.onClick)) {
                this.ui.bubble.addClass("pointer");
            }
        }
    });

    /**
     * In order to handle a css issue in Reporting module, we have to to add 24px to the "top" calculation.
     * We tried to add a Bubble-Wrapper for Reporting but we cant use it because Reporting use uiComponents that use Bubble as is.
     * We have to find by ourselves if the container is Reporting or not for any of the Bubble that rendered in the app.
     * @param container
     * @param ignoreOffsetByContainer
     * @returns {{top: number, left: number}}
     * @private
     */
    function _initOffset(container, ignoreOffsetByContainer) {
        ignoreOffsetByContainer = ignoreOffsetByContainer || false;
        var offset = {top: 0, left: 0};

        if (ignoreOffsetByContainer === true) {
            return offset;
        }

        if (_isReportingContainer(container)) {
            offset.top = 24;
        }
        if (_isConnectionPanelContainer(container)) {
            offset.top = 75;
        }
        if (_isPersonalizationContainer(container)) {
            offset.top = 75;
        }
        return offset;
    }

    function _isReportingContainer(container) {
        return (_.isFunction(container.hasClass) && container.hasClass(REPORTING_CLASS));
    }
    function _isConnectionPanelContainer(container) {
        return (_.isFunction(container.hasClass) && container.hasClass(CONNECTION_PANEL_CLASS));
    }

    function _isPersonalizationContainer(container) {
        return (_.isFunction(container.hasClass) && container.hasClass(PERSONALIZATION_PANEL_CLASS));
    }

    Bubble.POSITION = {
        TOP: 1,
        RIGHT: 2,
        BOTTOM: 3,
        LEFT: 4
    };

    Bubble.ALIGN = {
        MIDDLE: 1,
        LEFT: 2,
        RIGHT: 3,
        TOP: 4,
        BOTTOM: 5
    };

    Bubble.ICON = {
        ERROR: 1,
        WARNING_WHITE: 2,
        SUCCESS: 3,
        SUCCESS_WHITE: 4,
        PROGRESS: 5
    };

    Bubble.THEME = {
        DARK: 1,
        LIGHT:2
    };

    Bubble.PERMUTATION = {
        A: "A",
        B: "B",
        C: "C",
        D: "D",
        F: "F"
    };

    Bubble.TIMEOUT = 500;

    Bubble.DEFAULT_ZINDEX = DEFAULT_ZINDEX;

    return Bubble;
});

